export default __webpack_public_path__ + "static/media/icon_clock.0d23d46b.svg";